import { Box, Button, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';
// import Background from '../assets/images/signin.png';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { disptchCTAClickObject } from '../../Analytics';

const SignupPDP = ({ active, setActive }: CommonProps) => {
  const { t, i18n } = useTranslation();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowContent(active);
    }, 250);
  }, [active]);

  // const onLearnMore = () => {
  //   window.open('https://www.thebicestercollection.com/la-vallee-village/en/member', '_blank');
  // };

  const onSignup = () => {
    console.log('Langauge', i18n.language);
    let url = 'https://www.larocavillage.com/en/campaign/virtual-voyage/';
    const lang = i18n.language;

    if (lang === 'es') {
      url = 'https://www.larocavillage.com/es/campaign/virtual-voyage/';
    } else if (lang === 'ca') {
      url = 'https://www.larocavillage.com/ca/campaign/virtual-voyage/';
    } else if (lang === 'fr') {
      url = 'https://www.larocavillage.com/fr/campaign/virtual-voyage/';
    }

    disptchCTAClickObject('laroca', 'Button', 'Signup', 'Signup', url);
    window.open(url, '_blank');
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={showContent ? 1 : 0}
        visibility={showContent ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={showContent ? 1 : 0}
        visibility={showContent ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="0px 0px 40px 0px"
        width={['95vw', '400px', '750px', '850px']}
        height={['550px', '550px', '690px', '700px']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '35px']}
          right={['30px', '30px', '35px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        {/* <Image src={Background} alt="cover" width="800px" objectFit="contain" position="absolute" top="0" left="0" /> */}
        {active && (
          <ReactPlayer
            progressInterval={1}
            height="auto"
            width="100%"
            loop={true}
            muted
            controls={false}
            playing={active}
            url="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bister/laroca/membership_emperia.mp4"
            playsinline
          />
        )}
        <Box
          position="absolute"
          top={['170px', '170px', '345px', '430px']}
          left="0"
          w="100%"
          h={['350px', '350px', '350px', '250px']}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Text
            fontWeight="500"
            fontSize={['14px', '14px', '16px', '16px', '16px']}
            lineHeight={['18px', '18px', '18px', '20px', '20px']}
            maxW={['300px', '325px', '500px', '700px']}
            textAlign="center"
            className="copy"
            fontFamily="JosefinSans"
          >
            {t('signup_description')}
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          gap="3"
          justifyContent="center"
          alignItems="center"
          w="100%"
          position="absolute"
          bottom={['30px', '30px', '30px']}
          left="0px"
        >
          {/* <Button
            bg="white"
            border="1px solid gray"
            borderRadius="0px"
            w="150px"
            h="46px"
            color="#455255"
            _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            onClick={onLearnMore}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
              fontFamily="JosefinSans"
            >
              Learn more
            </Text>
          </Button> */}

          <Button
            bg="#C29F6B"
            color="white"
            borderRadius="0px"
            border="1px solid #C29F6B"
            h="46px"
            px="30px"
            _hover={{ bg: 'white', color: '#C29F6B' }}
            onClick={onSignup}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
              fontFamily="JosefinSans"
            >
              {t('signup_btn')}
            </Text>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default SignupPDP;
